// Metro resolves file paths, not package exports (unstable_enablePackageExports
// is off in the mobile app) — this root stub makes "@libs/rudderstack/cid"
// resolve there. Bundler-resolution consumers use the exports map instead.
export * from "./src/core/cid";
